<template>
  <div class="pa-3 mb-3">
    <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
        <v-snackbar top right v-model="snackbar" :color="snackbar_color" :timeout="2000" >
          <span>{{snackbar_message}}</span>
        </v-snackbar>
        <v-card class="neu-glow pb-3">
          <v-card-title primary-title>
            <div class="text-h5">Richieste</div>
            <v-spacer></v-spacer>
            <v-div>
              <!--
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" :disabled="requests_hash==JSON.stringify(requests)" @click.stop="saveItem()">
                    <v-icon color="error">mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Salva</span>
              </v-tooltip>
              -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click.stop="editItem(null)">
                    <v-icon color="info">mdi-plus-circle</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction=true">
                    <v-icon color="info">mdi-help-circle</v-icon>
                  </v-btn>
                </template>
                <span>Istruzioni</span>
              </v-tooltip>                           
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading" @click.stop="getData('refresh')">
                    <v-icon color="info">mdi-sync-circle</v-icon>
                  </v-btn>
                </template>
                <span>Refresh</span>
              </v-tooltip>
            </v-div>            
          </v-card-title>
          <!--
            <v-row v-if="loading">
                <v-col class="text-center">
                  <v-progress-linear
                    color="info"
                    height="10"
                    indeterminate
                    striped
                  ></v-progress-linear>
                </v-col>
            </v-row>-->
            <div  class="mx-4">
              <v-card class="neu-glow">
                <v-data-table
                  dense
                  fixed-header
                  :headers="headers"
                  :items="requests||[]"
                  hide-default-footer
                  :items-per-page=500
                  :item-class="itemClass"
                  :loading="loading"
                  no-data-text="Nessun dato presente in archivio"
                  no-results-text="Nessun Risultato estratto"
                  loading-text="Consultazione archivio: attendi..."
                >
                    <template v-slot:[`item.remarks`]="{ item }">
                      <div v-html="item.remarks"></div>
                    </template>

                    <template v-slot:[`item.active`]="{ item }">
                      <v-simple-checkbox
                        v-model="item.active"
                        color="info"
                        @click="save2(item.name, item.active)"
                      ></v-simple-checkbox>
                    </template>

                    <template v-slot:[`item.icon`]="{ item }">
                      <v-icon>{{item.icon}}</v-icon>
                    </template>
                    <template v-slot:[`item.waIcon`]="{ item }">
                      <div>{{item.waIcon}}</div>
                    </template>
                    <!--
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          color="warning"
                          class="mr-2"
                          @click="editItem(item)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          color="error"
                          @click="deleteItem(item)"
                        >
                          mdi-delete
                        </v-icon>
                    </template>
                    -->

                </v-data-table>
              </v-card>
  <!--
                <v-col cols="9" md="7"  :key="fi">
                  <vue-editor :id="fi" v-model="f.A" :editorToolbar="customToolbar"  class="mx-2"  />
                </v-col>
                <v-col cols="3" md="1" :key="fi">
                  <v-btn class="ml-1" block @click="editFaq(f)" color="red">Modifica</v-btn>
                </v-col>
                -->
          </div>
        </v-card>
    </v-form>
  <v-dialog v-model="dialog_instruction" max-width="800">
      <v-card>
          <v-card-title class="text-h5">
            Istruzioni
            <v-spacer></v-spacer>
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_instruction = false">
                    <v-icon color="info">mdi-close</v-icon>
                </v-btn>
                </template>
                <span>Esci</span>
            </v-tooltip>             
          </v-card-title>
          <v-divider></v-divider>
          <v-row class="mx-5 mt-0">
              <v-col md="6" cols="12">
                  <p>
                    Qualora voleste cambiare una icona basta cliccare sul pulsante scegli Icona <v-icon color="info">mdi-content-copy</v-icon>: si aprirà la finestra con tutte le icone della serie <strong>Google Material Design</strong>.
                  </p>
                  <p>
                    Scegliete quella che preferite cliccandoci sopra:<br>Si aprirà una ulteriore finestra con i dettagli dell'icona: In alto a sinistra è indicato il nome dell'icona, e passandoci sopra con il mouse apparirà la scritta <strong class="black white--text px-2 py-1 rounded text-caption">Copy Icon Name</strong>
                  </p>
              </v-col>
              <v-col md="6" cols="12">
                <p>
                  Cliccate sul nome dell'icona e chiudete entrambe le finestre
                </p>
                <p>
                  a questo punto cliccate sul pulsante "Incolla icona" <v-icon color="warning">mdi-content-paste</v-icon>
                </p>
                  <p>
                    Il pulsante 'Salva' <v-icon color="error">mdi-content-save</v-icon> si attiva: cliccatelo per salvare le nuove impostazioni.
                  </p>
              </v-col>
              <v-col cols="12">
                  <p class="red--text justify">
                      <strong>Attenzione: </strong>Ogni giorno vengono aggiunte e tolte icone al progetto Material Design Icons:<br>Purtroppo non possiamo adeguarci automaticamente all'ultima versione per problemi di retrocompatibilità, in quanto rischieremmo che alcune delle icone utilizzate improvvisamente spariscano:
                      <br>Se dopo aver cliccato su <v-icon color="warning">mdi-content-paste</v-icon> l'icona non appare significa che è stata introdotta successivamente.
                      <br>Ci scusiamo per l'inconveniente: stiamo studiando una soluzione al problema.
                  </p>
              </v-col>
          </v-row>
      </v-card>
  </v-dialog>    
    <v-dialog v-model="dialog_editItem" max-width="500">
        <v-card>
            <v-card-title class="text-h5 mb-3">
              {{editedItem.name?'Modifica Opzione':'Crea Nuova Opzione'}}
              <v-spacer></v-spacer>
              <v-div>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update" @click="saveItem('save')">
                      <v-icon color="error">mdi-content-save</v-icon>
                    </v-btn>
                  </template>
                  <span>Salva</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="editedItem={};dialog_editItem = false">
                      <v-icon color="info">mdi-close-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Esci</span>
                </v-tooltip>              
            </v-card-title>
            <v-divider></v-divider>
            <v-row class="mx-5 pt-3 mb-0">
                <!--<v-col md="3" cols="6" v-for="(d,i) in slots.filter(s=> s!='Giorno')" :key="i">-->
                <v-col cols="12">
                  <v-text-field
                    v-show="false"
                    label="Nome"
                    outlined
                    v-model=editedItem.active
                  >
                  </v-text-field>                  
                  <v-text-field            
                    counter
                    label="Nome"
                    outlined
                    v-model=editedItem.name
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="9">
                  <v-text-field            

                    counter
                    label="Descrizione"
                    outlined
                    v-model=editedItem.description
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field>
                </v-col>                               
                <v-col cols="3">
                  <v-text-field          
                    counter
                    label="Ordinamento"
                    outlined
                    type="number"
                    v-model=editedItem.sortOrder
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>                
                <v-col cols="8">
                  <v-text-field         
                    counter
                    label="icon"
                    outlined
                    :prepend-inner-icon="editedItem.icon"
                    v-model=editedItem.icon
                    persistent-placeholder
                    hide-details
                    :loading="loading_refresh"
                  >
                  </v-text-field> 
                </v-col>
                <v-col cols="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mt-2" @click="dialog_mdiIconsIframeOpen=true">
                        <v-icon color="info">mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>Scegli un'icona</span>
                  </v-tooltip>
                  </v-col>
                  <v-col cols="2">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mt-2" @click="pasteFromClipboard()">
                        <v-icon color="warning">mdi-content-paste</v-icon>
                      </v-btn>
                    </template>
                    <span>Incolla Icona</span>
                  </v-tooltip>
                </v-col>                 
            </v-row>
        </v-card>
    </v-dialog>
    <v-dialog eager v-model="dialog_mdiIconsIframeOpen" fullscreen transition="dialog-bottom-transition">
      <v-toolbar>
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-2" v-bind="attrs" v-on="on" icon @click="dialog_mdiIconsIframeOpen = false">
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>        
          <v-toolbar-title class="text-h5 mr-3">Icone</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon @click="dialog_instruction=true">
                <v-icon class="mr-2" color="info">mdi-help-box</v-icon>
              </v-btn>
            </template>
            <span>Istruzioni</span>
          </v-tooltip>               
          </v-toolbar-items>
        </v-toolbar>      
      <v-card>
        <iframe id="ifrm" src="https://pictogrammers.com/library/mdi/" width="100%" :height="(wHeight-110)+'px'" allow="clipboard-read; clipboard-write"></iframe>
      </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn icon color="info"  @click="dialog_mdiIconsIframeOpen = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>           
        </v-card-actions>      
    </v-dialog>
    <v-dialog v-model="dialog_delete" max-width="500px">
        <v-card>
            <v-card-title class="text-h5">
              Confermi Cancellazione?
              <v-spacer></v-spacer>
              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" :loading="loading_update"  @click="saveItem('delete')">
                      <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                  </template>
                  <span>Si, Confermo</span>
              </v-tooltip>   

              <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2"  @click="dialog_delete=false">
                      <v-icon color="info">mdi-close</v-icon>
                  </v-btn>
                  </template>
                  <span>No, Esci</span>
              </v-tooltip>              
            </v-card-title>
        </v-card>
    </v-dialog>          
  </div>
</template>
<script>
import { mapGetters } from "vuex";
//import _ from 'lodash'
export default {
  data() {
    return {
      page: "Settings",
      loading:false,
      loading_update:false,
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      snackbar_color:null,
      snackbar:false,
      snackbar_message:null,      
      dialog_editItem:false,
      dialog_delete:false,
      dialog_instruction:false,
      dialog_mdiIconsIframeOpen:false,
      requests_hash:null,
      requests:[],
      editedItem:{"icon":null,"description":null,"sortOrder":null,"name":null},
      empty_editedItem:{"icon":null,"description":null,"sortOrder":null,"name":null},
      loading_refresh:false,
      headers: [
                //{text: 'N', align: 'start', value: 'new'},
                { text: 'Ord',         value: 'sortOrder',          align: 'middle',    sortable: false, class:'px-1 text-lg-button' },
                { text: 'Descrizione',  value: 'description',       align: 'left',  sortable: false, class:'pl-1 text-lg-button' },
                //{ text: 'ID',           value: 'requestId',      align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Tipo',         value: 'dataType',      align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Icona',        value: 'icon',          align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Icona WA',     value: 'waIcon',        align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
                { text: 'Attiva',       value: 'active',        align: 'center',  sortable: false, class:'px-1 text-lg-button' },
                //{ text: 'Azione',       value: 'actions',       align: 'center',  sortable: false, class:'pl-1 text-lg-button' },
              ],
     
    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {
    item (newValue) {
      console.log(789,newValue)
      //this.getData(newValue)
    },
    assignedTable(newValue)
    {
      console.log(794,newValue)
      //this.assignedTables.push(newValue);
      console.log(796,newValue,this.assignedTables)
      this.assignTables(newValue);
    }
  },
  methods:
  {
    save2(field,value) {
      console.log(410,value, field);
      var pload={"optionId":field,"value":value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value===false?0:value===true?1:value===''?null:value};
      //var pload={[field]:value};
      //pload[field]=value;
      var action='saveItem';
      let payload={"action":action,"table":"User_Requests","payload":pload};
      console.log(413,payload)
      this.updateDB(payload)
    },    
    pasteFromClipboard()
    {
      navigator.clipboard.readText().then(
          (text) => {
              this.editedItem.icon= 'mdi-'+text
              //this.result = 'Text pasted from clipboard'
          },
          (err) => {
              console.error('Could not paste text: ', err)
          }
      )
    },    
    deleteItem(f)
    {
      this.editedItem=f;
      console.log(358,f)
      this.dialog_delete=true;
    },     
    editItem(f)
    {
      if(f)
        this.editedItem=f;
      console.log(364,f)
      this.dialog_editItem=true;
    },
    async saveItem(a)
    {
        console.log(144,this.editedItem);
        this.loading_update=true;
        console.log(255,this.form);
        var action='saveItem';
        var pl=null;
        switch (a)
        {
          case 'delete':            
            this.editedItem.deleted=true;
            pl='['+JSON.stringify(this.editedItem)+']';
          break;
          case 'save':
            this.editedItem.active=true;
            pl='['+JSON.stringify(this.editedItem)+']';
          break;
          default:
            pl=this.requests;
        }

        let payload={"action":action,"table":"AllRequests","payload":pl};
        console.log(257,payload)
        let w= await this.updateDB(payload)
        this.loading_update=false;
        this.editedItem={...this.empty_editedItem};
        console.log(260,w);
        if(w.errorid=='0')
        {
            this.snackbar_color="success"
            this.message =w.message;
            this.snackbar = true;
            this.dialog_editItem=false;
            this.dialog_delete=false;
            this.getData(402);
            //this.slotsByDOW_hash=JSON.stringify(this.slotsByDOW);
        }   
    },
    async getData(origin)
    {
        {
            if(origin=='refresh')
            {
              this.loading_refresh=true;
            }
            else
            {
              this.loading=true;
            }
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllRequests_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading_refresh=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.requests=res.data.payloads.AllRequests;
                    this.requests_hash=JSON.stringify(res.data.payloads.AllRequests)
                    console.log(315,this.requests)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        //try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            this.dialog_delete=false;
            this.editedItem={...this.empty_editedItem};
            if (res.data.errorid=='0')
            {
              sessionStorage.setItem('jwt', res.data.jwt);
              this.snackbar_color='success';
              this.snackbar_message=res.data.message;
              this.requests_hash=JSON.stringify(res.data.requests)

              if (res.data.message)
              {
                  console.log(333);
                  this.snackbar_message=res.data.message
                  this.snackbar_color="success";
                  this.snackbar=true;
                  this.requests_hash=JSON.stringify(res.data.requests)
              }
            }
            else
            {
              this.snackbar_color="error"
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
       /* } catch(e)
        {
        console.log(e);
        }*/
    },
  },
};
</script>